'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ProductFormatted } from '@/types/product'
import { useTranslations } from 'next-intl'
import { AmazonProductCard } from './amazon-product-card'

export function AmazonProductCarousel({
  products,
  gaTrackingValue,
  gaTrackingLabel,
  isSoldProduct,
}: {
  products: ProductFormatted[]
  gaTrackingValue?: string
  gaTrackingLabel?: string
  isSoldProduct?: boolean
}) {
  if (!products.length) return <EmptyProductCarousel />

  return (
    <Carousel
      opts={{
        align: 'start',
      }}
      className='w-full'
    >
      <CarouselContent>
        {products.map((product, index) => (
          <CarouselItem
            key={index}
            className='basis-1/2 md:basis-1/3 lg:basis-1/4'
          >
            <AmazonProductCard
              product={product}
              gaTrackingValue={gaTrackingValue}
              gaTrackingLabel={gaTrackingLabel}
              theme='light'
              isSoldProduct={isSoldProduct}
            />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className='left-0 top-1/2 -translate-y-1/2 max-md:hidden' />
      <CarouselNext className='right-0 top-1/2 -translate-y-1/2 max-md:hidden' />
    </Carousel>
  )
}

const EmptyProductCarousel = () => {
  const t = useTranslations()
  return (
    <div className='flex h-64 items-center justify-center rounded-lg bg-neutral-100'>
      <p className='text-neutral-500'>{t('common.no_product_found')}</p>
    </div>
  )
}
